import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatNavList, MatListItem } from '@angular/material/list';

import { TerraIconModule } from '@ninety/terra';

@Component({
  selector: 'ninety-help-dialog',
  templateUrl: './help-dialog.component.html',
  styleUrls: ['./help-dialog.component.scss'],
  standalone: true,
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatNavList,
    MatListItem,
    TerraIconModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class HelpDialogComponent {
  dialogRef = inject<MatDialogRef<HelpDialogComponent>>(MatDialogRef);
}
